const {
  i18n: { __ },
  components: { PanelBody, ToggleControl },
} = wp;

const Visibility = ({ blockVisibility, setAttributes, initialOpen = true }) => {
  return (
    <PanelBody title={__('Visibility', 'b3rg')} initialOpen={initialOpen}>
      <ToggleControl
        label="Disable | Enable"
        checked={blockVisibility}
        onChange={(newValue) => {
          setAttributes({ blockVisibility: newValue });
        }}
      />
    </PanelBody>
  );
};

export default Visibility;
